import React, { useState } from "react";
import CustomModal from "../../../../components/common/Modal";
import CustomTable from "../../../../components/common/CustomTable";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import { useDispatch, useSelector } from "react-redux";
import {
   addVendorChildAsync,
   updateVendorChildAsync,
} from "../../../../redux/features/vendorMaster";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";

const validationSchema = yup.object().shape({
   name: yup
      .string()
      .required("Vendor name is required.")
      .matches(/^[a-zA-Z][a-zA-Z-' ]{1,50}[a-zA-Z]$/, "Invalid name!"),
   email: yup
      .string()
      .email("Invalid email address")
      .required("Contact person email is required."),
   mobile: yup
      .string()
      .required("Contact person mobile number is required.")
      .matches(/^[0-9]{10,15}$/, "Invalid phone number"),
});

const EditContactPerson = ({ data, vendorId, setIsChildUpdated }) => {
   const [showModal, setshowModal] = useState(false);
   const [isChecked, setIsChecked] = useState(true);
   const [mode, setMode] = useState("edit");

   const contactPersonDetials = useSelector(
      (state) => state.vendorMaster.contactPersonData,
   );
   const dispatch = useDispatch();

   // close modal
   const handleCloseModal = () => {
      resetForm();
      setshowModal(false);
   };

   const toggleSwitch = () => {
      setIsChecked((prev) => !prev); // Toggle the state
   };

   // Edit button Handler
   const editHandler = (data) => {
      setMode("edit");
      setshowModal(true);
      setValues({
         name: data?.name,
         email: data?.email,
         mobile: data?.mobile,
         id: data?.id,
         vendorId: data?.vendor_master_id,
      });
   };

   // Add button handler
   const addButtonHandler = () => {
      setshowModal(true);
      setMode("add");
      resetForm();
   };

   const addContact = (formData) => {
      dispatch(backdropLoadingAction(true));
      const newData = new FormData();
      newData.append("vendor_master_id", vendorId);
      newData.append("model_id", 7);
      newData.append("action_id", 1);
      const ard = {
         contact_person_name: formData.name,
         mobile: formData.mobile,
         email: formData.email,
      };
      Object.keys(ard).forEach((key, index) => {
         newData.append(`${key}[]`, ard[key]);
      });

      dispatch(
         addVendorChildAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               setIsChildUpdated(true);
               handleCloseModal();
               toast.success("Updated successfully.");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   // for Update dispatch
   const updateContact = (formData) => {
      dispatch(backdropLoadingAction(true));
      const newData = new FormData();
      newData.append("vendor_master_id", formData.vendorId);
      newData.append("contact_person_detail_id", formData.id);
      newData.append("_method", "PATCH");
      newData.append("model_id", 7);
      newData.append("action_id", 2);

      // for array of elements
      const ard = {
         contact_person_name: formData.name,
         mobile: formData.mobile,
         email: formData.email,
      };
      Object.keys(ard).forEach((key, index) => {
         newData.append(`${key}[]`, ard[key]);
      });

      dispatch(
         updateVendorChildAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               setIsChildUpdated(true);
               handleCloseModal();
               toast.success("Updated successfully.");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: {
         name: "",
         email: "",
         mobile: "",
         id: "",
         vendorId: vendorId,
      },
      validationSchema,
      onSubmit: mode === "add" ? addContact : updateContact,
   });
   const {
      touched,
      errors,
      values,
      setValues,
      getFieldProps,
      setFieldValue,
      handleSubmit,
      resetForm,
   } = formik;

   const columns = [
      {
         name: "Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: "Email",
         selector: (row) => row.email,
      },
      {
         name: "Mobile",
         selector: (row) => row.mobile,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button type="button" className="btn" onClick={() => editHandler(row)}>
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={isChecked}
                     onChange={toggleSwitch}
                     id="vendor1"
                  />
               </div>
            );
         },
      },
   ];
   return (
      <>
         <CustomModal
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            onSubmit={handleSubmit}
            title={mode === "edit" ? "Edit Contact" : "Add Contact"}
            child={
               <>
                  <div className="">
                     <CustomInput
                        require
                        label="Contact Person Name"
                        inputType="text"
                        name="name"
                        placeholder="Enter Contact Person Name."
                        {...getFieldProps("name")}
                        errors={touched?.name && errors?.name}
                        message={errors?.name}
                     />
                  </div>
                  <div className="">
                     <CustomInput
                        inputType="number"
                        require
                        label="Mobile No"
                        name="mobile"
                        placeholder="Enter Contact Person Mobile No."
                        {...getFieldProps("mobile")}
                        errors={touched?.mobile && errors?.mobile}
                        message={errors?.mobile}
                     />
                  </div>
                  <div classmobile="">
                     <CustomInput
                        require
                        label="Email Id"
                        inputType="text"
                        id="#vendorEmail"
                        name="email"
                        placeholder="Enter Contact Person Email"
                        {...getFieldProps("email")}
                        errors={touched?.email && errors?.email}
                        message={errors?.email}
                     />
                  </div>
               </>
            }
         />
         <div className="d-flex justify-content-between mb-2">
            <h3>Contact Person Details</h3>
            <button type="button" className="btn btn-primary" onClick={addButtonHandler}>
               <i className="fas fa-plus"></i> Add contact
            </button>
         </div>
         <CustomTable columns={columns} data={data} />
      </>
   );
};

export default EditContactPerson;
